/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {StorageUnit} from '../models/storageUnit';
import {getOrCreateStorageUnitEndpoint} from '../middleware/endpoints/storageUnits';

export class StorageUnitStore extends EntityStore {
  storageUnits = [];

  constructor(rootStore) {
    super(rootStore, 'storageUnits', Api.storageUnits, StorageUnit);
  }

  async getByNo(storageUnitNo) {
    let storageUnit = this.storageUnits.find((unit) => unit.no === storageUnitNo);
    if (!storageUnit) {
      await this.loadAll({params: {no: storageUnitNo}});
      storageUnit = this.storageUnits.find((unit) => unit.no === storageUnitNo);
    }
    return storageUnit;
  }

  async getOrCreateByNo(storageUnitNo) {
    let storageUnit;
    try {
      await this.create(
        {no: storageUnitNo},
        {
          apiEndpoint: getOrCreateStorageUnitEndpoint,
          skipNotification: true,
        }
      );
      storageUnit = this.storageUnits.find((unit) => unit.no === storageUnitNo);
    } catch (e) {
      this.handleApiError(e);
    }
    return storageUnit;
  }
}

decorate(StorageUnitStore, {
  storageUnits: observable,
});
